import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

const ShipmentReturnTableRow = (props) => {
  return (
    <tr>
      <td>
        <NavLink to={`/return/${props.item.returned}/`}>
          {props.item.returned}
        </NavLink>
      </td>
      <td>
        <NavLink to={`/inventory/${props.item.id}/`}>
          {props.item.id}
        </NavLink>
      </td>
      <td className="hidden-xxs-down">#{props.item.shipment_package}</td>
      <td>{props.item.item.name}</td>
      <td className="hidden-xs-down">{props.item.station.name}</td>
      <td className="hidden-xs-down">{(props.item.extra_info && props.item.extra_info.grade)? props.item.extra_info.grade.grade: 'N/A'}</td>
      <td className="hidden-xs-down">{props.item.brand? props.item.brand.brand_name : '-'}</td>
      <td className="hidden-xs-down">{moment(props.item.returned_date).format('L')}</td>
    </tr>
  )
}

export default class ShipmentReturnsList extends Component {

  render() {
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h5>Returned</h5>
        </div>
        <div className="card">
          <table className="table table-striped table-hover mb-0">
            <thead className="thead-inverse">
              <tr>
                <th>Return</th>
                <th>Item Id</th>
                <th className="hidden-xxs-down">Package Id</th>
                <th>Item</th>
                <th className="hidden-xs-down">Station</th>
                <th className="hidden-xs-down">Grade</th>
                <th className="hidden-xs-down">Brand</th>
                <th className="hidden-xs-down">Returned Date</th>
              </tr>
            </thead>
            {this.props.returns.length > 0 ?
              <tbody>
              {this.props.returns.map((item, index)=>{
                return <ShipmentReturnTableRow item={item} key={index} />
              })}
              </tbody>
            :
              null
            }
          </table>
          {this.props.returns.length === 0 ?
            <div className="empty-table">
              <span>No returned items for this shipment</span>
            </div> : null 
          }
        </div>
      </div>
    );
  }
}
